import React from 'react';
import { Phone, Search, CalendarCheck, Wrench, Info } from 'lucide-react';
export function QuoteProcess() {
  const steps = [{
    number: '1',
    icon: Phone,
    title: 'Call or Request an Urgent Quote',
    copy: 'Call 517-545-7772 for fastest help or submit the short form.'
  }, {
    number: '2',
    icon: Search,
    title: 'Confirm the Damage',
    copy: 'The team will ask about your vehicle, which glass is broken, whether it is safe to drive, and whether photos are available.'
  }, {
    number: '3',
    icon: CalendarCheck,
    title: 'Check Glass & Schedule Availability',
    copy: "Kosin's Glass confirms glass availability, insurance details and the fastest appointment options."
  }, {
    number: '4',
    icon: Wrench,
    title: 'Repair, Replace & Calibrate If Needed',
    copy: 'Certified technicians complete the repair or replacement. ADAS calibration is handled if required after windshield replacement.'
  }];
  const sidebarItems = ['Vehicle year, make and model', 'Which glass is damaged', 'Photo of the damage', 'Insurance company information', 'Whether the vehicle is safe to drive', 'Best callback number'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-178">
      <div className="max-w-7xl mx-auto" data-id="element-179">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-180">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-181">
            How Your{' '}
            <span className="text-brand-red" data-id="element-182">Emergency Auto Glass Quote</span>{' '}
            Works
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-183">
          {/* Steps */}
          <div className="lg:col-span-2 space-y-5" data-id="element-184">
            {steps.map((step, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 flex gap-5 items-start shadow-sm" data-id="element-185">
                <div className="shrink-0 w-12 h-12 sm:w-14 sm:h-14 bg-brand-red rounded-full flex items-center justify-center text-white font-black text-xl shadow-sm" data-id="element-186">
                  {step.number}
                </div>
                <div data-id="element-187">
                  <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-188">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-189">{step.copy}</p>
                </div>
              </div>)}
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1" data-id="element-190">
            <div className="bg-white rounded-xl p-6 sm:p-7 shadow-sm border border-slate-200 sticky top-6" data-id="element-191">
              <div className="flex items-center gap-2.5 mb-5" data-id="element-192">
                <div className="bg-brand-redLight p-2 rounded-md" data-id="element-193">
                  <Info className="w-5 h-5 text-brand-red" data-id="element-194" />
                </div>
                <h3 className="text-lg font-bold text-slate-900" data-id="element-195">
                  For faster help, have these ready:
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-196">
                {sidebarItems.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-197">
                    <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-brand-red flex items-center justify-center" data-id="element-198">
                      <span className="w-1.5 h-1.5 bg-brand-red rounded-full" data-id="element-199" />
                    </span>
                    <span className="text-slate-700 text-sm" data-id="element-200">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}